<template>
  <div>
    <div class="head">
      <div class="title">
        <div class="logo fl">
          <img src="../../assets/img/logo.png" alt />
        </div>
        <h1>RAKUMART</h1>
      </div>
    </div>
    <div class="body" style="display: flex">
      <div class="img fl">
        <img src="../../assets/img/login.png" alt />
        <h3>美好的一天从你开始...</h3>
      </div>
      <div class="login fl">
        <h2>登录</h2>
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="username">
            <div class="input">
              <el-input v-model="loginForm.username" placeholder="请输入账号" size="mini"></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="input">
              <el-input v-model="loginForm.password" placeholder="请输入密码" size="mini" type="password"></el-input>
            </div>
          </el-form-item>
        </el-form>
        <input type="checkbox" name="jizhu" v-model="jizhu" />
        <span>记住密码</span>

        <a href="javascript:;" @click="login">立即登录</a>
        <div class="wx" @click="getQrcodeImg"> <img src="@/assets/icon/qywx.png" alt="">企业微信扫描登录
        </div>
      </div>
    </div>
    <!-- 验证码 -->
    <el-dialog title="第一次登录需要输入验证码" :close-on-click-modal="false" :visible.sync="dialogVisible" width="450px" center>
      <div class="row">
        <div class="label">验证码:</div>
        <div class="val">
          <el-input v-model="loginForm.code" placeholder="请输入手机验证码"></el-input>
        </div>
        <div class="code">
          <el-button @click="sendAdminLoginValidateCode" type="primary" v-if="show">获取验证码</el-button>
          <a href="javascript:;" v-else>{{ Countdown }}秒后再次操作</a>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="login">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 微信登录 -->
    <wxLogin ref="wxLogin" />
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import wxLogin from './wxLogin'
export default {
  components: { wxLogin },
  data() {
    return {
      dialogVisible: false,
      show: true,
      Countdown: 60,
      loginForm: {
        username: localStorage.getItem("username"),
        password: localStorage.getItem("password"),
        system: 1,
        compute_token: localStorage.getItem("compute_token"),
        code: "",
      },
      //记住密码
      jizhu:
        localStorage.getItem("username") && localStorage.getItem("password")
          ? true
          : false,
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {
    let that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.login(); // 登录方法名
        return false;
      }
    };
    if (location.host.indexOf('.com') !== -1) {
      setTimeout(() => {
        this.getQrcodeImg()
      }, 1000);
    }

  },
  methods: {
    ...mapMutations(["getUserInfo"]),
    login() {
      if (this.jizhu == true) {
        localStorage.setItem("username", this.loginForm.username);
        localStorage.setItem("password", this.loginForm.password);
      } else {
        localStorage.removeItem("username");
        localStorage.removeItem("password");
      }
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$api.login(this.loginForm).then((res) => {
            // 第一次登陆需要验证手机验证码  后台登录万能验证码:wn666
            if (res.code == "10003") {
              this.dialogVisible = true;

            } else {
              localStorage.setItem("japan_access_token", res.data.access_token);
              document.cookie = `japan_access_token=${res.data.access_token} ${res.data.userInfo.id}`;

              localStorage.setItem(
                "japanUserRoleInfo",
                JSON.stringify(res.data.userInfo)
              );
              localStorage.setItem(
                "japanUserRoleStatus",
                res.data.userInfo.role[0].work_type
              );
              // 验证过的手机号 不删除，保留
              if (res.data.compute_token) {
                localStorage.setItem("compute_token", res.data.compute_token);
              }
              this.$store.dispatch("userAuth");
              this.$store.dispatch("getMenu");
              // 日本事务所 和义乌分开跳转
              if (this.loginForm.username == 'JP010') {
                this.$router.replace("/menu3_japanfirm");
              } else {
                this.$router.replace("/homePage");
              }
            }
          });
        }
      });
    },
    // 发送验证码
    sendAdminLoginValidateCode() {
      this.$api
        .sendAdminLoginValidateCode(this.loginForm)
        .then((res) => {
          this.$message.success(res.msg);
          //   倒计时
          this.show = false;
          var timer = setInterval(() => {
            this.Countdown -= 1;
            if (this.Countdown <= 0) {
              this.show = true;
              this.Countdown = 60;
              clearInterval(timer);
            }
          }, 1000);
        });
    },
    //微信登录
    getQrcodeImg() {
      this.$refs.wxLogin.dialogVisible = true
      this.$refs.wxLogin.generateQrCode()
    },
  },
};
</script>
<style lang='scss' scoped>
.fl {
  float: left;
}

.flexAndCenter {
  display: flex;
  align-items: center;
}

.flexAndBetween {
  display: flex;
  justify-content: space-between;
}

.registerContainer {
  margin-right: 20px;
  cursor: pointer;
}

.head {
  height: 200px;
  //   background: #036eb8;
  border-bottom: 2px solid #036eb8;

  .title {
    width: 805px;
    margin: 0 auto;
    height: 200px;
    overflow: hidden;

    .logo {
      width: 400px;
      height: 100px;
      margin-top: 50px;
      margin-right: 100px;

      img {
        height: 100px;
      }
    }

    h1 {
      float: left;
      font-size: 36px;
      font-weight: 700;
      //   color: #fff;
      line-height: 200px;
    }
  }
}

.body {
  width: 805px;
  height: 365px;
  margin: 70px auto;
  background: #eee;
  border-radius: 5px;

  .img {
    width: 400px;

    img {
      display: block;
      margin: 57px auto 10px;
    }

    h3 {
      font-weight: 700;
      font-size: 14px;
      color: #666;
      margin-left: 75px;
    }
  }

  .login {
    margin: 3px 3px 0 0;
    width: 315px;
    height: 327px;
    padding: 32px 0 0 86px;
    background: #fff;
    border-radius: 5px;

    h2 {
      font-weight: 700;
      font-size: 24px;
      color: #333;
      margin-bottom: 30px;
    }

    .input {
      width: 240px;
      height: 30px;
    }

    input {
      background-color: #fff;
      vertical-align: middle;
      margin-left: 15px;
    }

    span {
      font-size: 14px;
      font-weight: 700;
      color: #333;
      margin-left: 5px;
    }

    .wx {
      cursor: pointer;
      text-align: center;
      width: 240px;

      img {
        width: 20px;
        vertical-align: middle;
        margin-right: 10px;
      }
    }


    a {
      display: block;
      width: 240px;
      height: 34px;
      background: #036eb8;
      color: #fff;
      text-align: center;
      line-height: 34px;
      margin: 30px 0 15px;
      //   font-weight: 700;
      font-size: 16px;
      border-radius: 3px;
      // margin-left: 10px;
    }
  }
}

/deep/.el-form-item__error {
  margin: 5px 0 0 10px;
}

.row {
  display: flex;
  padding: 0 20px;
  line-height: 40px;

  .label {
    flex: 1;
  }


  .val {
    flex: 3;
    margin-right: 20px;
  }

  .code {
    flex: 2;
  }
}
</style>